import { Text, Box } from '@mantine/core';

import { brand, pusatCabangActive, appVersion } from "../utils/globalVariables";

const BrandComponent = () => {
    return (
        <Box>
            <Text
                fw='bold'
                size='lg'
                tt='uppercase'

                variant="gradient"
                gradient={{ from: 'cyan', to: 'blue', deg: 90 }}

                sx={{
                    fontFamily: 'Greycliff CF, sans-serif',
                    paddingTop: '3px',
                    letterSpacing: '1px'
                }}
            >
                {brand.shortName} {pusatCabangActive.flagCaption}
            </Text>

            <Text
                fw='bold'
                size='sm'
                tt='uppercase'

                variant="gradient"
                gradient={{ from: 'cyan', to: 'blue', deg: 90 }}

                sx={{
                    fontFamily: 'Greycliff CF, sans-serif',
                    letterSpacing: '1px'
                }}
            >
                {pusatCabangActive.shortName}
            </Text>

            <Text
                variant="gradient"
                gradient={{ from: 'cyan', to: 'blue', deg: 30 }}
                mt='.25rem'
                style={{
                    fontSize: '.75rem',
                }}
            >
                Version {appVersion}
            </Text>
        </Box>
    )
}

export default BrandComponent;